export default __webpack_public_path__ + "static/media/anjitha.9e7deec8.png";